import { Vector2, Vector3 } from "three";
import { MathX } from "./MathX";

export interface Vectorial<V>
{
  clone():Vectorial<V>;

  add( other:V|Vectorial<V> ):V;
  sub( other:V|Vectorial<V> ):V;
  multiplyScalar( scale:number):V;
  divideScalar( scale:number):V; 

  length():number 

}

export class MathV
{
  static multipliedSum<V>( output:Vectorial<V>, ...segments:[Vectorial<V>,number][]):V
  {
    for ( let segment of segments )
    {      
      let vector = segment[ 0 ];
      let weight = segment[ 1 ];
      let weighted = vector.clone().multiplyScalar(  weight );

      output.add( weighted )
    }

    return output as any as V;
  }

  static lerpAsRange( range:Vector2, t:number )
  {
    return MathX.lerpUnclamped( range.x, range.y, t );
  }

  static lerpClampedAsRange( range:Vector2, t:number )
  {
    t = MathX.clamp01( t );
    return MathX.lerpUnclamped( range.x, range.y, t );
  }

  static maxVector3( ...vectors:Vector3[] )
  {
    if ( vectors.length === 0 )
    {
      return null;
    }

    let output = vectors[ 0 ].clone();
    
    for ( let i = 1; i < vectors.length; i++ )
    {
      let v = vectors[ i ];
      
      output.x = Math.max( output.x, v.x );
      output.y = Math.max( output.y, v.y );
      output.z = Math.max( output.z, v.z );
    }


    return output;
  }

  static minVector3( ...vectors:Vector3[] )
  {
    if ( vectors.length === 0 )
    {
      return null;
    }

    let output = vectors[ 0 ].clone();
    
    for ( let i = 1; i < vectors.length; i++ )
    {
      let v = vectors[ i ];
      
      output.x = Math.min( output.x, v.x );
      output.y = Math.min( output.y, v.y );
      output.z = Math.min( output.z, v.z );
    }


    return output;
  }
}